module.exports = __webpack_public_path__ + "assets/img/face_check_example1.1c8c2160.png";